export const locationsData = [
	{
		id: 1,
		location: 'Los Angeles',
		storeHour: 'Hours: 6AM-7PM',
		address: '9400 S Normandie Ave',
		city: 'Los Angeles',
		state: 'CA',
		phoneNumber: '323-238-0610',
		link: '/locations/los-angeles-9400-s-normandie-ave',
		lat: 33.9505914,
		lng: -118.3000693
	},
	{
		id: 2,
		location: 'Lake Forest',
		storeHour: 'Hours: 6AM-7PM',
		address: '23311 Muirlands Blvd',
		city: 'Lake Forest',
		state: 'CA',
		phoneNumber: '631-726-7517',
		link: '/locations/lake-forest-23311-muirlands-blvd',
		lat: 33.6302205,
		lng: -117.7047599
	},
	{
		id: 3,
		location: 'San Diego',
		storeHour: 'Hours: 6AM-7PM',
		address: '3710 Pio Pico St',
		city: 'San Diego',
		state: 'CA',
		phoneNumber: '619-222-4374',
		link: '/locations/san-diego-3710-pio-pico-st',
		lat: 32.7145216,
		lng: -117.2461397
	},
	{
		id: 4,
		location: 'Santa Monica',
		storeHour: 'Hours: 6AM-7PM',
		address: '205 Georgina Ave',
		city: 'Santa Monica',
		state: 'CA',
		phoneNumber: '310-393-7824',
		link: '/locations/santa-monica-205-georgina-ave',
		lat: 34.0270409,
		lng: -118.5114475
	}
];
